module.exports = __webpack_public_path__ + "img/75mg-braftovi.32eef85c.png";